import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Channel root used to be a separate overview page, but Calendar / Analytics /
 * Settings already cover that job in the sidebar. Land on the per-channel
 * calendar instead (Buffer-style).
 */
export const Route = createFileRoute("/(app)/channels/$id/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/channels/$id/publish",
      params: { id: params.id },
      replace: true,
    });
  },
});
